<template>
  <div>
    <div ref="image_viewer" style="position: absolute; left: -9999; top: -9999">
      <img 
        v-for="(o, index) in image.list"
        style="width: 100px; height: 100px;" 
        :key="index" 
        :src="o.src"
        @load="() => onImageViewerChildLoad(o)"/>
    </div>
    <el-dialog
      :visible.sync="music.viewer.visible"
      :show-close="false"
      :width="(music.viewer.width + 50) + 'px'"
      :before-close="done => {
        $refs.music_viewer.$el.getElementsByTagName('AUDIO')[0].pause();
        $refs.music_viewer.$el.getElementsByTagName('AUDIO')[0].src = null;
        $nextTick(() => done());
      }">
      <av-bars
        v-if="music.viewer.visible"
        ref="music_viewer"  
        :bar-color="['#0d0d5e', '#312b87', '#6a4ec7', '#a341f5', '#ff00ff', '#ff007f', '#008cff', '#00c9ff', '#00ff9e']"
        :canv-width="music.viewer.width"
        :caps-height="2"
        :brick-height="6"
        :symmetric="false"
        :fft-size="music.viewer.fft"
      ></av-bars>
      <!-- <av-line 
        v-if="music.viewer.visible"
        ref="music_viewer" 
        :line-width="3.6" 
        :line-color="['#ff00ff', '#00ffff', '#ffcc00', '#ff007f', '#00ff00']"
        :canv-width="music.viewer.widh">
      </av-line> -->
    </el-dialog>
    <video 
      ref="video_viewer" >
      <source :src="video.src">
      您的浏览器不支持播放视频
    </video>
  </div>
</template>

<script>
import { ApplicationContext } from '@/utils/context';
import { setTimeout } from 'core-js';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

export default {
  name: 'FileViewer',
  components: {
  },
  data: () => {
    return {
      image: {
        list: [],
        viewer: null
      },
      video: {
        src: ''
      },
      music: {
        viewer: {
          visible: false,
          src: null,
          width: 300,
          fft: 1024
        }
      },
      loading: null
    }
  },
  props: {
    platform: String
  },
  methods: {
    handleFullscreenChange() {
      if (!document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement) {
        this.$refs.video_viewer && !this.$refs.video_viewer.paused && this.$refs.video_viewer.pause();
      }
    },
    requestFullscreen(element) {
        // 进入全屏
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) { // Firefox
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) { // Chrome, Safari and Opera
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) { // IE/Edge
          element.msRequestFullscreen();
        }
    },
    onImageViewerChildLoad(o) {
      o.loaded = true;
      let cnt = 0;
      this.image.list.forEach(o => {
        if (o.loaded) {
          cnt++;
        } 
      });
      if (this.image.list && cnt == this.image.list.length && 0 < cnt) {
        if (!this.image.viewer) {
          let that = this;
          this.$refs.image_viewer.addEventListener('hidden', () => {
            that.image.list = [];
          });
          this.$refs.image_viewer.addEventListener('show', () => {
            setTimeout(() => that.loading && that.loading.close(), 10);
          });
          this.image.viewer = new Viewer(this.$refs.image_viewer, {
            inline: false,    // 是否嵌入页面显示
            navbar: true,    // 是否显示导航栏
            title: false,     // 是否显示图片标题
            zoomable: true,  // 是否允许缩放
            scalable: true,  // 是否允许旋转
            fullscreen: true, // 是否允许全屏显示
            transition: false, // 禁用过渡动画，提升性能
            toolbar: {
              zoomIn: false,
              zoomOut: false,
              oneToOne: { size: 'large' },
              prev: { size: 'large' },
              play: false,
              next: { size: 'large' },
              reset: { size: 'large' },
              rotateLeft: { size: 'large' },
              rotateRight: { size: 'large' },
              flipHorizontal: { size: 'large' },
              flipVertical: { size: 'large' }
            },
          });
        } 
        this.$nextTick(() => {
          this.image.viewer.update();
          this.$nextTick(() => {
            this.image.viewer.show();
            this.$nextTick(() => {
              if (1 < this.image.list.length) {
                document.getElementsByClassName('viewer-prev')[0].style.display = "block";
                document.getElementsByClassName('viewer-next')[0].style.display = "block";
              } else {
                document.getElementsByClassName('viewer-prev')[0].style.display = "none";
                document.getElementsByClassName('viewer-next')[0].style.display = "none";
              }
            });
          });  
        });
      }
    }
  },
  mounted() {
    let that = this;
    document.addEventListener('fullscreenchange', that.handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', that.handleFullscreenChange); // for Safari
    document.addEventListener('mozfullscreenchange', that.handleFullscreenChange); // for Firefox
    document.addEventListener('MSFullscreenChange', that.handleFullscreenChange); // for IE/Edge
    ApplicationContext.$on('do_viewing_file', async (file) => {
      if ('image' === file.type) {
        that.loading = this.$loading({ lock: true, spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
        let response = await fetch(file.url);
        if (!response.ok) {
            throw new Error(`Failed to fetch image: ${response.statusText}`);
        }
        const blob = await response.blob();
        let url = URL.createObjectURL(blob);
        that.image.list = [{ src: url }];
      } else if ('music' == file.type) { 
        let loading = this.$loading({ lock: true, spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
        let response = await fetch(file.url);
        if (!response.ok) {
            throw new Error(`Failed to fetch audio: ${response.statusText}`);
        }
        let blob = await response.blob();
        let url = URL.createObjectURL(blob);
        that.music.viewer.visible = true;
        if ('windows' === that.platform) {
          that.music.viewer.width = 900;
          that.music.viewer.fft = 2048;
        } 
        that.$nextTick(() => {
          let audio = that.$refs.music_viewer.$el.getElementsByTagName('AUDIO')[0];
          audio.style.width = (that.music.viewer.width + 20) + 'px';
          audio.src = url;
          audio.play();
          loading.close();
        });
      } else if ('video' === file.type) {
        that.video.src = file.url;
        that.$nextTick(() => {
          that.$refs.video_viewer.load();
          that.$refs.video_viewer.play().catch((error) => console.error('播放失败:', error));
          that.requestFullscreen(that.$refs.video_viewer);
        });
      } else if ('pdf' == file.type) {
        that.loading = this.$loading({ lock: true, spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
        ApplicationContext.$off('finish_rendering_pdf');
        ApplicationContext.$on('finish_rendering_pdf', async event => {
            ApplicationContext.$off('finish_rendering_pdf');
            that.image.list = Array.from(event.pages)
              .map(page => { 
                return {src: page.toDataURL('image/png')}; 
              });
        });
        ApplicationContext.$emit('do_rendering_pdf', file.url);  
      } else if ('word' == file.type) {
        that.loading = this.$loading({ lock: true, spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
        ApplicationContext.$off('finish_rendering_docx');
        ApplicationContext.$on('finish_rendering_docx', async event => {
            ApplicationContext.$off('finish_rendering_docx');
            that.image.list = [{ src: event.canvas.toDataURL('image/png') }];
        });
        ApplicationContext.$emit('do_rendering_docx', file.url);  
      } 
    });
  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange); // for Safari
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange); // for Firefox
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange); // for IE/Edge
    ApplicationContext.$off('do_viewing_file');
    this.image.viewer = null;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
